import { takeLatest, put } from 'redux-saga/effects';
import {
  setCommissionDueIndex,
  commissionDueIndexFailed,
  LOAD_COMMISSION_DUE_INDEX
} from './reducer';
import { getRequest } from '../../../utilities/requests';

function* handleLoadCommissionDueIndex() {
  try {
    const url = '/pending_commission_payouts';
    const response = yield getRequest(url);
    yield put(setCommissionDueIndex(response.data));
  } catch (error) {
    yield put(commissionDueIndexFailed());
  }
}

export function* loadCommissionDueIndexSaga() {
  yield takeLatest(LOAD_COMMISSION_DUE_INDEX, handleLoadCommissionDueIndex);
}
